module.exports = __webpack_public_path__ + "static/media/instagram-polos.17e5b670.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/instagram-polos.svg
// module id = 777
// module chunks = 0